import { useLazyQuery } from '@apollo/client';
import { GetAudienceDocument } from '../../../graphql/query/audiences/GetAudience.generated.tsx';

export function useAudienceOptionsDetailsLazyFetch() {
  const [getAudienceDetailsQuery] = useLazyQuery(GetAudienceDocument);

  const fetchAudienceDetails = async (audienceId: string) => {
    if (!audienceId) {
      return null;
    }

    return await getAudienceDetailsQuery({
      variables: {
        id: audienceId.replace('openaudience-', ''),
      },
    });
  };

  return {
    fetchAudienceDetails,
  };
}
